import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import HelpService from "../../../Components/HelpService";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import Universities from "../../../Components/Universities";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const LiveSessionChatHelp = () => {
  const subCategoryId = "65a17a11740c57094df25ee7";
  const categoryId = "65524e353c005ef3b51907c2";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Live Session Help" },
    { label: "1-1 Chat" },
  ];
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />

      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection />
      <HelpService
        helpServiceTitle
        subCategoryID={subCategoryId}
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <div className="mt-4">
        <HelpSteps
          subCategoryId={subCategoryId}
          description="Get your 1-1 Chat support in 4 easy steps"
        />
      </div>
      {/* <Milestonerewards categoryId={categoryId} /> */}
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "LiveSessionHelp",
            type: "livesessionHelp",
            totalSteps: 3,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default LiveSessionChatHelp;
